import {Steps} from 'shared/tools';

const STEPS = [
  {
    name: 'recruiting.interview_schedules.edit.Interview Details',
    location: 'interview_details'
  },
  {
    name: 'recruiting.interview_schedules.edit.Interviewers',
    location: 'interviewers'
  },
  {
    name: 'recruiting.interview_schedules.edit.Availability',
    location: 'availability'
  },
  {
    name: 'recruiting.interview_schedules.edit.Invitation Email',
    location: 'invitation_email'
  },
  {
    name: 'recruiting.interview_schedules.edit.Review',
    location: 'review'
  }
].map((s, i) => ({...s, index: i + 1}));

const steps = new Steps(STEPS);

export default steps;
